// extracted by mini-css-extract-plugin
export default {"wrapper":"BackToLink_wrapper__ELusr"};